/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Configure an action on a transition.
 * 
 * The action name is gated by the same two-layer registry check the admin uses, against the
 * owner of the transition's workflow.
 * @export
 * @interface TransitionActionWrite
 */
export interface TransitionActionWrite {
    /**
     * 
     * @type {string}
     * @memberof TransitionActionWrite
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionActionWrite
     */
    transition: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionActionWrite
     */
    actionName: string;
    /**
     * Position of the action on the transition, used for ordering.
     * @type {number}
     * @memberof TransitionActionWrite
     */
    readonly position: number;
}

/**
 * Check if a given object implements the TransitionActionWrite interface.
 */
export function instanceOfTransitionActionWrite(value: object): value is TransitionActionWrite {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('transition' in value) || value['transition'] === undefined) return false;
    if ((!('actionName' in (value as Record<string, any>)) && !('action_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['actionName'] === undefined && (value as Record<string, any>)['action_name'] === undefined)) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function TransitionActionWriteFromJSON(json: any): TransitionActionWrite {
    return TransitionActionWriteFromJSONTyped(json, false);
}

export function TransitionActionWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransitionActionWrite {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'transition': json['transition'],
        'actionName': json['action_name'],
        'position': json['position'],
    };
}

export function TransitionActionWriteToJSON(json: any): TransitionActionWrite {
    return TransitionActionWriteToJSONTyped(json, false);
}

export function TransitionActionWriteToJSONTyped(value?: Omit<TransitionActionWrite, 'id'|'position'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transition': value['transition'],
        'action_name': value['actionName'],
    };
}

